export default __webpack_public_path__ + "static/media/area-47.7eeb8431.jpg";